<template>
    <div>
        <div v-if="materials.length">
            <div
                class="flex mt-2 border-t border-gray-200 bg-gray-100 text-xs text-gray-500 font-semibold">
                <div class="flex-1 border-r border-l border-gray-200 px-2 py-1 -ml-px">Material
                </div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px">UoM</div>
                <div class="w-28 border-r border-gray-200 px-2 py-1 -ml-px text-right">Quantity
                </div>
            </div>
            <cost-plan-material-item
                v-if="materials.length"
                v-for="(material,index) in materials" :item="material" @change="editMaterial"
                :cost-plan="costPlan"
                :readOnly="readonly"
                :key="'mat'+index">
            </cost-plan-material-item>
            <div class="flex">
                <div class="flex-1 border-t"></div>
            </div>
        </div>
        <div v-else
             class="flex border bg-gray-50 border-gray-200 mt-1 rounded rounded-lg -mb-px border-gray-200">
            <div class="flex-1 -ml-px  font-italic text-center text-xs text-gray-400 p-2">
                No Materials
            </div>
        </div>
    </div>
</template>

<script>

import {CostPlan} from '@models';
import UiToggle from "../../../ui/UiToggle.vue";
import CostPlanMaterialItem from "./CostPlanMaterialItem.vue";
import UiSidepage from "../../../ui/UiSidepage.vue";
import {resolveNumericText, toCurrency} from "../../../../utils";
import costPlan from "../CostPlan.vue";

export default {
    computed: {
    },
    components: {
        UiSidepage,
        CostPlanMaterialItem,
        UiToggle,
    },
    props: {
        costPlan: Object,
        readonly: Boolean,
        materials: []
    },
    watch: {
        costPlan: {
            handler(newValue, oldValue) {
                this.renderKey++
            },
            deep: true,
        },
    },
    data() {
        return {
        }
    },
    async mounted() {
    },
    methods: {
        toCurrency,
        editMaterial(from, to) {
            this.$emit("editMaterial", from, to);
        },
    }
}
</script>
